import { useMemo } from 'react';

import { DirectoryRecordData } from 'api/types/data';
import { OrderOperationType } from 'api/types/entity/order';
import { useField } from 'modules/order/common/forms/orderForm';
import { useOrderContext } from 'modules/order/common/providers/OrderProvider';

import { SenderOrRecipientDetailsSectionProps } from './types';

export const useSenderOrRecipientDetailsSection = ({
  type,
}: SenderOrRecipientDetailsSectionProps) => {
  const {
    orderType,
    directories: { senderOrRecipientDetails },
  } = useOrderContext();

  const { helpers: custodianOrganizationCodeHelpers } = useField(
    `${
      type === 'recipient' ? 'recipientDetails' : 'senderDetails'
    }.custodianOrganizationCode`
  );

  const {
    isDisabledAccountNumber,
    isDisabledAccountOwnerName,
    isDisabledBrokerName,
  } = useMemo(() => {
    let isDisabledAccountNumber = false;
    let isDisabledAccountOwnerName = false;
    let isDisabledBrokerName = false;

    if (orderType === OrderOperationType.SecuritiesWithdrawal) {
      isDisabledAccountNumber = type === 'sender';
      isDisabledAccountOwnerName = type === 'sender';
      isDisabledBrokerName = type === 'sender';
    } else if (orderType === OrderOperationType.SecuritiesDeposit) {
      isDisabledAccountNumber = type === 'recipient';
      isDisabledAccountOwnerName = type === 'recipient';
      isDisabledBrokerName = type === 'recipient';
    }

    return {
      isDisabledAccountNumber,
      isDisabledAccountOwnerName,
      isDisabledBrokerName,
    };
  }, [orderType, type]);

  const onChangeCustodianOrganization = (
    params: {
      value: string;
      label: string;
      record?: DirectoryRecordData;
    } | null
  ) => {
    if (params?.record) {
      const { record } = params;

      const code = record.fields.find((field) => field.name === 'code');
      custodianOrganizationCodeHelpers.setValue(
        code?.value?.toString() || undefined
      );
    } else {
      custodianOrganizationCodeHelpers.setValue(undefined);
    }
  };

  return {
    isDisabledAccountNumber,
    isDisabledAccountOwnerName,
    isDisabledBrokerName,
    senderOrRecipientDetails,
    onChangeCustodianOrganization,
  };
};
